/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Povucite za promjenu veličine panela',
  command_intelligence_close_aria: 'Zatvori asistenta',
  command_intelligence_send_aria: 'Pošalji poruku',
  command_intelligence_stop_aria: 'Zaustavi odgovor',
  command_intelligence_composer_input_aria: 'Poruka za Command Intelligence',
  command_intelligence_drawer_more_options: 'Više opcija',
  command_intelligence_dock_position: 'Položaj sidrišta',
  command_intelligence_dock_left: 'Lijevo',
  command_intelligence_dock_right: 'Desno',
  command_intelligence_dock_top: 'Gore',
  command_intelligence_dock_bottom: 'Dolje',
  command_intelligence_panel_layout: 'Raspored panela',
  command_intelligence_panel_layout_overlap: 'Preklapanje sadržaja',
  command_intelligence_panel_layout_push: 'Pomakni sadržaj',
  command_intelligence_panel_auto_hide_overlap: 'Automatski sakrij pri kliku izvan',
  command_intelligence_session_reset: 'Resetiraj razgovor',
  command_intelligence_try_one_of_these: 'Isprobajte jedno od ovih',
  command_intelligence_attach_hint: 'Priložite kontekstne stavke kako biste počeli postavljati pitanja.',
  command_intelligence_attach_modal_title: 'Priloži kontekst',
  command_intelligence_attach_modal_subtitle: 'Odaberite iz stavki u ovom prikazu. Već priložene stavke su zasivljene.',
  command_intelligence_attach_modal_search_placeholder: 'Pretraži…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# stavka dostupna} few {# stavke dostupne} other {# stavki dostupno}} · {selected} odabrano',
  command_intelligence_attach_modal_empty: 'Ništa nije dostupno za prilaganje',
  command_intelligence_attach_modal_no_results: 'Nijedna stavka ne odgovara pretrazi',
  command_intelligence_context_bar_attached_section: 'Priloženo ({count})',
  command_intelligence_context_bar_clear_attached: 'Očisti',
  command_intelligence_context_bar_add: 'Priloži kontekst',
  command_intelligence_placeholder_ready: 'Postavite pitanje…',
  command_intelligence_placeholder_attach: 'Priložite kontekst za postavljanje pitanja…',
  command_intelligence_composer_submit_hint: 'Enter za slanje · Shift+Enter za novi red',
  command_intelligence_composer_stop_hint: 'Zaustavi · skiciraj sljedeću poruku dok čekate',
  command_intelligence_response_stopped: 'Odgovor zaustavljen',
  command_intelligence_generation_in_progress: 'Obrada vašeg pitanja',
  command_intelligence_generation_trace_title: 'Poduzeti koraci',
  command_intelligence_generation_trace_toggle: 'Prikaži korake',
  command_intelligence_generation_trace_summary: '{completed} od {total} koraka dovršeno',
  command_intelligence_generation_trace_summary_generic: 'Koraci generiranja',
  command_intelligence_generation_tool_count: '{count, plural, one {# alat} few {# alata} other {# alata}}',
  command_intelligence_generation_turn_label: 'Krugu {turn} od {total}',
  command_intelligence_generation_turn_completed: 'Krugu {turn} od {total} dovršen',
  command_intelligence_generation_turn_completed_elapsed: 'Krugu {turn} od {total} dovršen ({seconds}s proteklo)',
  command_intelligence_generation_turn_completed_with_tools: 'Krugu {turn} od {total} dovršen – korišteno {tools}',
  command_intelligence_generation_tools_used: 'Korišteno {tools}',
  command_intelligence_reasoning_thinking: 'Razmišljam…',
  command_intelligence_reasoning_thought_for_seconds: 'Razmišljao {seconds} sekundi',
  command_intelligence_reasoning_waiting: 'Obrada vašeg pitanja…',
  command_intelligence_attach_modal_done: 'Gotovo',
  command_intelligence_attach_modal_attached_badge: 'priloženo',
  command_intelligence_attach_modal_attach: 'Priloži',
  command_intelligence_attach_modal_attach_count: 'Priloži ({count})',
  command_intelligence_attach_modal_close_aria: 'Zatvori birač',
  command_intelligence_session_limit_context: 'Dosegnuto ograničenje konteksta. Resetirajte razgovor za nastavak.',
  command_intelligence_session_limit_prompt: 'Dosegnuto ograničenje poruka. Resetirajte razgovor za nastavak.',
  command_intelligence_suggested_followups: 'Predložena dodatna pitanja',
  command_intelligence_credit_warning_line: '{pct}% mjesečnih AI kredita za {scope} iskorišteno',
  command_intelligence_tooltip_prompts: '{count} od {max} poruka ({pct}%)',
  command_intelligence_tooltip_context: '{used} od {max} kontekstnih tokena ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Korištenje konteksta pojavljuje se nakon prvog odgovora',
  command_intelligence_credits_loading: 'Učitavanje kredita…',
  command_intelligence_credits_unavailable: 'Krediti nisu dostupni',
  command_intelligence_credits_tooltip: 'Mjesečni AI krediti za {monthKey}',
  command_intelligence_credits_tooltip_short: 'Mjesečni AI krediti',
  command_intelligence_credits_scope_profile: 'Profil',
  command_intelligence_credits_scope_entity: 'Entitet',
  command_intelligence_credits_used_of_cap: '{used} od {cap} kredita',
  command_intelligence_credits_used_no_cap: '{used} kredita iskorišteno',
  command_intelligence_credits_monthly_title: 'Mjesečni AI krediti',
  command_intelligence_compare_aria: 'Usporedi agente',
  command_intelligence_compare_tooltip: 'Pokreni isto pitanje na više profila agenata',
  command_intelligence_compare_cancelled: 'Usporedba otkazana',
  command_intelligence_compare_branch_failed: 'Grana usporedbe nije uspjela',
  command_intelligence_compare_title: 'Usporedba agenata',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} ulaz / {outTok} izlaz · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Dobar odgovor',
  command_intelligence_feedback_bad_response: 'Loš odgovor',
  command_intelligence_feedback_dialog_title: 'Pošalji povratnu informaciju',
  command_intelligence_feedback_dialog_body:
    'Pomozite nam poboljšati se davanjem povratne informacije o ovom odgovoru. Vaša povratna informacija bit će poslana našem operativnom timu.',
  command_intelligence_feedback_response_label: 'Odgovor',
  command_intelligence_feedback_input_label: 'Vaša povratna informacija (neobavezno)',
  command_intelligence_feedback_input_placeholder: 'Što je bilo pogrešno ili nekoristno u ovom odgovoru?',
  command_intelligence_feedback_submit: 'Pošalji povratnu informaciju',
  command_intelligence_feedback_submit_error: 'Slanje povratne informacije nije uspjelo. Pokušajte ponovno.',
  command_intelligence_feedback_question_understanding: 'Je li agent razumio što ste htjeli?',
  command_intelligence_feedback_question_readability: 'Je li odgovor bio jednostavan za čitanje i korištenje?',
  command_intelligence_feedback_section_understanding: 'Razumijevanje',
  command_intelligence_feedback_section_readability: 'Čitljivost',
  command_intelligence_feedback_choice_none: 'Nijedno',
  command_intelligence_feedback_choice_misunderstood_task: 'Pogrešno shvaćen zadatak',
  command_intelligence_feedback_choice_ignored_constraint: 'Ignorirano ograničenje',
  command_intelligence_feedback_choice_wrong_scope: 'Pogrešan opseg',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Vizualno teško za čitanje',
  command_intelligence_feedback_choice_wrote_too_much: 'Previše napisano',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Objašnjenje nije pouzdano',
  command_intelligence_copy_aria: 'Kopiraj u međuspremnik',
  command_intelligence_error_missing_invoke_permission:
    'Nemate dopuštenje za korištenje Command Intelligencea za ovog agenta. Zamolite administratora da dodijeli potrebna Intelligence dopuštenja (na primjer analyst).',
  command_intelligence_access_denied_title: 'Potreban pristup',
  command_intelligence_error_session_expired: 'Vaša sesija je istekla. Osvježite stranicu i ponovno se prijavite.',
};
